import styled from "styled-components";

/**
 * 스크린 리더 전용(sr-only) 요소 — display:none/visibility:hidden은 낭독 자체를 막으므로
 * clip 방식으로 시각만 숨긴다. 라이브 리전(role="status" 등)과 결합해 시각적 변화를
 * 비시각 사용자에게 알리는 용도. 소비처도 같은 패턴이 필요하면 이 하나를 쓴다 — 시각 문구를
 * 지우는 대신 낭독 계약을 남길 때(드롭·이동 결과 안내 등).
 */
export const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
`;
